import { create } from "zustand";

const defaultResponseData = {
  isScreeningApplicable: false,
  job_id: "",
  category_id: "",
  isDraft: false,
  communication: ""
};

const usePostJobSuccessStore = create(set => ({
  responseData: { ...defaultResponseData },
  // Method to save response data
  setResponseData: response => set({ responseData: response }),

  // Method to reset response data to default
  clearResponseData: () => set({ responseData: {} })
}));

export default usePostJobSuccessStore;
